import KategoriaAktEuPage from './KategoriaAktEuPage';

export default KategoriaAktEuPage;
